import api from '@/apis'
import * as TYPES from './mutationTypes'
import dayjs from 'dayjs'
export default {
  getSubscribeQueryLists({ commit }, params) {
    return api.home
      .getSubscribeQueryList(params)
      .then(response => response.data)
      .then(result => {
        commit(TYPES.GET_ALL_SUBSCRIBE, {
          result,
          params
        })
        return result
      })
      .catch(error => Promise.reject(error))
  },
  //区块
  getBlockLists({ commit }, params) {
    return api.home
      .getBlockList(params)
      .then(response => response.data)
      .then(result => {
        result.items.forEach(item => {
          item.createAt = item.createAt.substring(5, 19).replace('T', '  ')
          item.timestamp =  dayjs(item.timestamp*1000).format('MM-DD HH:mm:ss')
        })
        commit(TYPES.GET_BLOCK_LIST, {
          result,
          params
        })
        return result
      })
      .catch(error => Promise.reject(error))
  },
  //合约
  getContractLists({ commit }, params) {
    return api.home
      .getContractList(params)
      .then(response => response.data)
      .then(result => {
        result.items.forEach(item => {
          item.createAt = item.createAt.substring(5, 19).replace('T', '  ')
          item.updateAt = item.updateAt.substring(5, 19).replace('T', '  ')
        })
        commit(TYPES.GET_CONTRACT_LIST, {
          result,
          params
        })
        return result
      })
      .catch(error => Promise.reject(error))
  },
  //交易
  getTxnLists({ commit }, params) {
    return api.home
      .getTxnList(params)
      .then(response => response.data)
      .then(result => {
        result.items.forEach(item => {
          item.createAt = item.createAt.substring(5, 19).replace('T', '  ')
          item.timestamp =  dayjs(item.timestamp*1000).format('MM-DD HH:mm:ss')
        })
        commit(TYPES.GET_TXN_LIST, {
          result,
          params
        })
        return result
      })
      .catch(error => Promise.reject(error))
  }
}
